import {Component} from '@angular/core';

@Component({
  selector: 'app-ngxcharts-page',
  templateUrl: 'ngxcharts-page.component.html'
})
export class NgxchartsPageComponent {
}
